import { GoodProfileProductType } from "../../../../graphql/generated";

type GoodLike = {
  _id?: string | null;
  goodId?: string | null;
  goodProfileId?: string | null;
};

type ProfileLike = { _id: string; productType?: GoodProfileProductType | null };

/**
 * Builds a lookup keyed by commodityId -> productType.
 *
 * An assignment's commodityId is not consistent: for SHIPPED goods it is the
 * good's `_id`, for RECEIVED goods it is the `goodProfileId`. To resolve either
 * way, the resulting map is keyed by BOTH the good id and the goodProfileId,
 * and is additionally seeded with every profile's `_id`.
 */
export function buildProductTypeByCommodity(
  goods: GoodLike[],
  goodProfiles: ProfileLike[],
): Record<string, GoodProfileProductType | undefined> {
  const profileType = new Map<string, GoodProfileProductType | undefined>();
  for (const profile of goodProfiles) {
    profileType.set(profile._id, profile.productType ?? undefined);
  }

  const map: Record<string, GoodProfileProductType | undefined> = {};

  // Seed every profile id (covers received-goods commodityId = goodProfileId
  // even when that profile is not referenced by any good in the list).
  for (const profile of goodProfiles) {
    map[profile._id] = profile.productType ?? undefined;
  }

  for (const good of goods) {
    const gpId = good.goodProfileId;
    if (!gpId) {
      continue;
    }
    const goodKey = good._id ?? good.goodId;
    const type = profileType.get(gpId);
    if (goodKey) {
      map[goodKey] = type;
    }
    map[gpId] = type;
  }

  return map;
}
